<template>
  <div class="flex flex-col justify-between bg-white border border-gray-100 rounded-lg shadow-sm w-full mt-4 min-h-screen">
    <div v-if= "issues.data.length" class="flex flex-col space-y-1 w-full text-expressgray mb-5">
    <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-b border-gray-100 p-4 sm:p-5">
     <h2 class="text-base sm:text-lg font-semibold text-gray-900">Support</h2>
     <div class="flex items-center gap-10 sm:gap-16">
      <h2 class="text-sm sm:text-base font-semibold text-expressgray">Status</h2>
      <h2 class="text-sm sm:text-base font-semibold text-expressgray">Action</h2>
     </div>

    </div>

              <div v-for="issue in issues.data" :key="issue.id">
                  <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-b border-gray-100 p-4 sm:p-5">
                    <div class="flex items-center space-x-4 ">
                      <svg class="w-6 h-6 fill-yellow" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 6a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 100 4v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2a2 2 0 100-4V6z"></path></svg>
                      <div class="div flex flex-col">

                          <p class="text-sm sm:text-base font-medium text-gray-900">{{issue.title}}</p>
                          <p class="text-sm text-expressgray">{{getHumanDate(issue.created_at) }}</p>
                      </div>

                  </div>

          <div class="flex items-center space-x-4">

                <span
                   v-if="issue.status === 'Under Investigation' "
                   class="rounded-full bg-yellow-100 text-yellow-700 px-3 py-1.5 text-center text-xs font-medium">
                       {{issue.status}}
                </span>

                 <span
                    v-else
                    class="rounded-full bg-green-100 text-green-700 px-3 py-1.5 text-center text-xs font-medium">
                       {{ issue.status}}
                 </span>


            <router-link
                :to="generate_issue_url(issue.id)">
              <p class="border border-gray-200 rounded-lg px-3 py-1.5 cursor-pointer text-sm text-expressgray hover:bg-gray-50 transition-colors"> Details </p>
            </router-link>

          </div>
        </div>

      </div>

      </div>

      <div v-else>
          <p class="text-center text-lg text-expressgray p-6">No issues found</p>
      </div>

       <div class="mx-auto p-4">
                <pagination :total-pages="totalPages"
                            :total="total"
                            :per-page="perPage"
                            :current-page="currentPage"
                            :has-more-pages="hasMorePages"
                            @pagechanged="showMore">
                </pagination>
              </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
 name: "SupportTicket",

 created(){

          this.totalPages = this.issues.to
          this.total = this.issues.total
          this.perPage = this.issues.per_page
          this.currentPage = this.issues.current_page
          this.hasMorePages = this.issues.last_page > this.issues.current_page



        this.$store.dispatch('issue/action_issues',{
            toast:this.$toast,
            router:this.$router
          });

          console.log('issues',this.issues)
  },
  data(){
    return {
      showfilter:false,
        totalPages: 1,
        total: 10,
        perPage: 5,
        currentPage :  1,
        hasMorePages: true,
        isLoading:false,
        showModel: false
    }
  },

  computed:{
        ...mapGetters({
          issues: 'issue/issues',
           getUser: 'authentication/getUser',
        })},

  methods: {
     getHumanDate : function (date) {
                return moment(date, 'YYYY-MM-DD').fromNow();
                // .format('Do MMMM,YYYY');
     },
      generate_issue_url: function (topic_uid){
          return `/report/${topic_uid}/details`
        },
    // generate_issue_url_admin: function (topic_uid){
    //   return `/report/${topic_uid}/details`
    // }
  }
}
</script>

<style>

</style>
